module.exports = __webpack_public_path__ + "img/4.680d4ad8.png";